import { ChangeDetectionStrategy, Component, effect, inject, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { SwitchComponent } from '../../../components/switch/switch.component';
import { GalleryService } from '../../../services/gallery.service';
import { UpgradeBadgeComponent } from '../../../shared-extra/components/pro-tag/upgrade-badge.component';
import { BillingScopePipe } from '../../../shared-extra/pipes/billing-scope.pipe';
import { AccessItemBodyComponent } from '../access-item-body/access-item-body.component';
import { AccessItemCtaComponent } from '../access-item-cta/access-item-cta.component';
import { AccessItemHeaderComponent } from '../access-item-header/access-item-header.component';
import { AccessItemIconComponent } from '../access-item-icon/access-item-icon.component';
import { AccessItemComponent } from '../access-item/access-item.component';
import { GallerySettingsCustomizeButtonComponent } from '../gallery-settings-customize-button/gallery-settings-customize-button.component';
import { GallerySettingsIconComponent } from '../gallery-settings-icon/gallery-settings-icon.component';

@Component({
  selector: 'app-asset-status-setting-item',
  imports: [
    AccessItemComponent,
    AccessItemHeaderComponent,
    AccessItemCtaComponent,
    AccessItemIconComponent,
    SwitchComponent,
    FormsModule,
    GallerySettingsIconComponent,
    AccessItemBodyComponent,
    GallerySettingsCustomizeButtonComponent,
    UpgradeBadgeComponent,
    BillingScopePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './asset-status-setting-item.component.html',
})
export class AssetStatusSettingItemComponent {
  galleryService = inject(GalleryService);
  gallery = input.required<GalleryDto>();
  assetStatus = model<boolean>();
  customize = output<void>();

  constructor() {
    effect(() => {
      const gallery = this.gallery();
      if (!gallery) return;
      const assetStatus = gallery.enabled_feedback_options.includes('status');
      if (this.assetStatus() === assetStatus) return;
      this.assetStatus.set(assetStatus);
    });
  }

  updateAssetStatus() {
    const options = this.gallery().enabled_feedback_options;
    if (this.assetStatus()) {
      options.push('status');
    } else {
      options.splice(options.indexOf('status'), 1);
    }

    this.galleryService.updateGallery(this.gallery(), {
      enabled_feedback_options: options,
    });
  }
}
